import { createContext, useContext } from 'react'

const ToastContext = createContext(null)

const useToastContext = () => {
  const context = useContext(ToastContext)

  if (context === undefined) {
    throw new Error('ToastContext must be used within a ToastProvider')
  }
  return {
    ...context,
  }
}

export { ToastContext, useToastContext }
